<template>
  <span v-show="showTimeViewer">
    <slot v-bind:timer="timeView">
      {{ timeView }}
    </slot>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    endTime: {
      type: Date,
      default: null,
    },
    showTimeViewer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      creditDate: new Date(),
      endDate: new Date(),
      isWaitingTime: false,
      isClosedToday: false,
    }
  },
  computed: {
    ...mapGetters('product', ['getServiceStartHour']),
    timeDiff() {
      const deadline = this.endDate
      const now = this.creditDate
      return deadline - now
    },
    timeView() {
      let result = '00:00:00'
      if (this.isWaitingTime) {
        return result
      }
      const diff = new Date(this.timeDiff)
      const temp = diff.toISOString().split('T')[1]
      result = temp.split('.')[0]

      const hh = Math.floor(diff / (60 * 60 * 1000))
      if (hh > 23) {
        // const mm = diff.getMinutes()
        // const ss = diff.getSeconds()
        // result = `${hh}:${mm}:${ss}`

        const days = Math.floor(hh / 24)
        result = `${days}일 ${result}`
      }
      return result
    },
    isToday() {
      const now = new Date()
      return now.getDate() === this.creditDate.getDate()
    },
  },
  watch: {
    endTime: {
      immediate: true,
      handler(v) {
        if (!!v) {
          this.endDate = v
        } else {
          const temp = new Date()
          temp.setHours(16)
          temp.setMinutes(0)
          temp.setSeconds(0)
          temp.setMilliseconds(0)
          this.endDate = temp
        }
      },
    },
    timeDiff: {
      immediate: true,
      handler(v) {
        const now = new Date()
        this.isWaitingTime = this.endDate <= now && now.getHours() < this.getServiceStartHour

        if (v < 0) {
          this.isClosedToday = true
        }
      },
    },
    isWaitingTime: {
      immediate: true,
      handler(nv, ov) {
        if (nv === true) {
          this.$emit('emitIsWaitingTime', true)
        } else {
          if (ov === true) {
            this.$emit('emitIsWaitingTime', false)
          }
        }
      },
    },
  },
  created() {
    this.setCreditDate()
  },
  methods: {
    getNow() {
      return new Date(this.creditDate.getTime())
    },
    setCreditDate() {
      setInterval(() => {
        const now = new Date()
        if (this.isClosedToday) {
          this.creditDate.setDate(now.getDate() + 1)
        } else {
          this.creditDate = now
        }
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped></style>
